export default Alpine.data('taskEditGoogleMap', (livewireInstance, task) => {
    return {
        bootMap() {
            const center = {
                lat: task.lat,
                lng: task.lng
            };

            window.initMap('map', center);
            this.addMarker(center);
        },
        async addMarker(position) {
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")

            const draggableMarker = new AdvancedMarkerElement({
                map: window.map,
                position: position,
                gmpDraggable: true,
            });

            draggableMarker.addListener("dragend", (event) => {
                const position = draggableMarker.position;

                livewireInstance.updateTaskLocation(position.lat, position.lng);
            });
        },
    }
});
